/**
 * @param {string} cacheName
 * @param {string} resourceUrl
 * @returns {Promise<Response>}
 */
export async function cacheResource (cacheName, resourceUrl) {
	const cache = await window.caches.open(cacheName);
	const response = await window.fetch(resourceUrl);
	if (!response.ok) {
		throw new Error(`fetch resource ends with "${response.status}"`);
	}
	await cache.put(resourceUrl, response.clone());
	return response;
}

/**
 * @param {string} cacheName
 * @param {string} resourceUrl
 * @returns {Promise<Response | undefined>}
 */
export async function getCacheResponse (cacheName, resourceUrl) {
	const cache = await window.caches.open(cacheName);
	return cache.match(resourceUrl);
}

/**
 * @param {string} cacheName
 * @param {string[]} resourcesUrl
 * @returns {Promise<void>}
 */
export async function clearCacheResponse (cacheName, resourcesUrl) {
	// const cache = await window.caches.open(cacheName);
	// const cachedResources = await cache.keys();
	// const outdatedResources = cachedResources.filter((request) => !resourcesUrl.includes(request.url));
	// await Promise.all(outdatedResources.map((request) => cache.delete(request)));
}
